import { postForm, get } from './index';
import { apiMap } from '@common/assets/ts/const';
// 初始化微信配置
export const apiInitWxConfig = (url: string) => {
    return postForm(`${apiMap.apiBc}/api/v1/h5/get-share-info`, { url, });
};

// 获取用户信息
export const apiUserInfo = (params?: Record<string, any>) => {
    return get(`${apiMap.apiMa}/marathon/api/v1/user-info`, params);
};
